/*
 * Eski hesap adreslerinin şemaya göre karşılığı (09.10.2026).
 *
 * Spinlab şemasında hesap sayfaları `/account/...` adreslerindedir; ortak
 * hesap sayfaları (para yatırma/çekme …) iç bağlantılarını bu yardımcıyla
 * kurar, Spinlab arayüzünde `/hesap/...` bağlantısı kalmaz. Diğer şemalarda
 * adres değişmez. Rotalar (App.js) eski adresi de aynı tabloyla yönlendirir.
 */
import { useCallback } from 'react';
import { useActiveTheme } from './activeTheme';

export const SPINLAB_ACCOUNT_REDIRECTS = {
  profil: '/account/settings',
  kyc: '/account/settings?tab=verify',
  guvenlik: '/account/settings?tab=security',
  affiliate: '/account/affiliates',
  'para-yatir': '/account/deposit',
  'para-yatir/odeme': '/account/deposit/payment',
  'para-cek': '/account/withdraw',
  'para-cek/hesap': '/account/withdraw/account',
  mesajlar: '/account/messages',
  islemler: '/account/activity',
  'oyun-gecmisi': '/account/game-history',
  'bahis-kuponlari': '/account/coupons',
  'kayip-bonusu': '/account/loss-bonus',
  bonuslarim: '/account/my-bonuses',
};

/** `/hesap/<eski>` sayfa anahtarı → Spinlab adresi; sorgu dizeleri birleşir. */
export const spinlabAccountTarget = (page, search = '') => {
  const target = SPINLAB_ACCOUNT_REDIRECTS[page];
  if (!target) return null;
  const [path, query = ''] = target.split('?');
  const params = new URLSearchParams(query);
  new URLSearchParams(search).forEach((value, key) => { if (!params.has(key)) params.set(key, value); });
  const text = params.toString();
  return text ? `${path}?${text}` : path;
};

/** Tam eski adres (`/hesap/para-yatir?view=history`) → Spinlab adresi. */
export const toSpinlabAccountPath = (href) => {
  const match = /^\/hesap\/([^?#]+)(\?[^#]*)?/.exec(String(href || ''));
  if (!match) return href;
  return spinlabAccountTarget(match[1].replace(/\/+$/, ''), match[2] || '') || href;
};

/** Şemaya göre hesap adresi kurar: `accountPath('/hesap/para-cek')`. */
export const useAccountPath = () => {
  const themeId = useActiveTheme();
  return useCallback((href) => (themeId === 'spinlab' ? toSpinlabAccountPath(href) : href), [themeId]);
};
